export const ModalActions = {
    AddModalPortal: "addModalPortal",
    RemoveModalPortal: "removeModalPortal"
} as const;
